"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Revert = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Revert = function Revert() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.713 22.573C19.395 22.573 24 17.968 24 12.287 24 6.606 19.395 2 13.713 2 8.032 2 3.427 6.606 3.427 12.287H.809a.56.56 0 00-.411.171l-.229.229a.571.571 0 000 .811l4.035 4.046c.226.22.585.22.811 0l4.035-4.046a.572.572 0 000-.811l-.229-.229a.56.56 0 00-.411-.171H5.712a8 8 0 118.001 8A7.898 7.898 0 019.28 18.94a.572.572 0 00-.72.068l-.823.835a.571.571 0 00-.16.446c.014.169.102.323.24.422a10.161 10.161 0 005.897 1.863zm0-12.572a2.286 2.286 0 110 4.572 2.286 2.286 0 010-4.572z",
    clipRule: "evenodd"
  });
};

exports.Revert = Revert;